var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "maintenance_box" }, [
    _c("p", { staticClass: "maintenance_title" }, [
      _vm._v(_vm._s(_vm.generalLabel.MAINTENANCE_TITLE))
    ]),
    _c("p", { staticClass: "maintenance_text" }, [
      _vm._v(_vm._s(_vm.generalLabel.MAINTENANCE_MESSAGE_1)),
      _c("br"),
      _vm._v(_vm._s(_vm.generalLabel.MAINTENANCE_MESSAGE_2))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }